<template>
  <div class="dialog_box">
    <div class="close_box"><IconClose @click.native="clickClose" /></div>
    <!-- logo -->
    <div class="dialog_logo" />
    <p class="dialog_title">毒霸官方合作的办公内容平台</p>

    <!-- 二维码 -->
    <div class="qr_box">
      <h3 class="qr_title">微信登录</h3>
      <div class="qr">
        <QrIframe
          v-show="loginUrlWechat" scrolling="no" :height="148" :width="148"
          :url="loginUrlWechat" />
        <div class="wechat_icon" />
      </div>
      <p class="desc">使用微信扫描二维码<strong>注册/登录</strong></p>
    </div>

    <div class="user_agreement_box">
      <p class="font">登录即同意《<a class="agreement" @click="clickUserProtocol">用户协议</a>》</p>
    </div>
    <div class="login_box">
      <!-- <div class="login_item" @click="clickLogin" /> -->
      <!-- <p class="login_item_desc">QQ登录</p> -->
      <p class="login_item_desc">(QQ登录正在开发中，请耐心等待！)</p>
    </div>
  </div>
</template>

<script>
import IconClose from '@/components/Icons/IconClose.vue'
import QrIframe from '@/views/Login/QrIframe.vue'

import WeChatAuth from '@/plugins/auth/wechatAuth.js'

import {
  ClientCloseTable, ClientOpenBrowser, ClientOpenTemplateByUrl,
  ClientSetUserInfo
} from '@/api/clientApi.js'
import { urlUserProtocol, urlClientQQLogin } from '@/common/resources.js'
import { CacheGetSource } from '@/common/cache.js'
import api from '@/api'
import { RetCode } from '@/api/bussinessCode.js'
import { report } from '@/report/index.js'

export default {
  name: 'LoginDialog',

  components: { IconClose, QrIframe },

  data () {
    return {
      loginUrl: '',
      loginUrlWechat: '',
      wechatClass: new WeChatAuth({ isStyle: true }),
    }
  },

  created () {
    this.reportLogin(1)

    this.loginWechat()
    this.listenMessage()
  },

  destroyed () {
    window.removeEventListener('message', this.listenFunc)
  },

  methods: {
    reportLogin (step, type = '') {
      report('login', { step, usertype: type, ext: '3' })
    },

    loginWechat () {
      this.loginUrlWechat = this.wechatClass.openAuthPage()
    },

    listenMessage () {
      window.addEventListener('message', this.listenFunc)
    },

    listenFunc (data) {
      if (data.data && typeof data.data === 'string') {
        const newData = JSON.parse(data.data)
        const search = newData.search

        if (!search) { return }

        const searchState = search.state
        const wechatState = this.wechatClass.getState()

        if (!searchState || searchState !== wechatState) { return }

        if (!search.code) { return }

        this.userLogin(search.code) // LoginType第三方接口传过去的参数
      }
    },

    userLogin (code) {
      const params = { login_type: 1, code, login_app: 'chestnutoffice', channel: CacheGetSource() }

      api.user.login({ data: params }).then(res => {
        const data = res.data

        const userType = data?.user_info?.is_new_user === 0 ? 2 : 1 // 默认是新注册

        // 存储userInfo，下一步上报需要
        const userInfo = { token: data.token, ...data.user_info }
        ClientSetUserInfo(userInfo)

        this.getPrivliege(userInfo, userType) // 获取用户权益
      }).catch(() => {
        this.$toast({ desc: '登录异常，请联系客服或关闭重试' })
      })
    },

    getPrivliege (userInfo, userType) {
      let privliegeName = ''
      let privliegeEndTime = ''
      let isVip = false

      api.user.privliege({ data: { common: { token: userInfo.token, uid: userInfo.uid } } }).then(pRes => {
        privliegeName = pRes.data.name
        privliegeEndTime = pRes.data.end_date
        isVip = true
      }).catch(data => {
        if (data?.ret && data.ret.toString() in RetCode) {
          privliegeName = RetCode[data.ret]
        }
      }).finally(() => {
        const lastUserInfo = { privliegeName, privliegeEndTime, isVip, ...userInfo }

        this.reportLogin(8, userType)

        ClientSetUserInfo(lastUserInfo)
        setTimeout(() => { // 上面方法s是微任务，所以，得给个异步
          ClientCloseTable()
        }, 100)
      })
    },

    clickClose () { ClientCloseTable() },

    clickUserProtocol () { ClientOpenBrowser(urlUserProtocol) },

    clickLogin () { ClientOpenTemplateByUrl(urlClientQQLogin) }
  }
}
</script>

<style lang="scss" scoped>
$color: #4a96e8;

.dialog_box {
  width: 434px;
  height: 454px;
  margin: 6px 0 0 6px;
  background-color: #fff;
  box-shadow: $box_shadow_dialog;

  .close_box { box-sizing: border-box; height: 30px; padding: 10px; overflow: hidden; font-size: 0; text-align: right; }

  .dialog_logo { height: 32px; background-image: url(~@/assets/images/logo.png); background-repeat: no-repeat; background-position: center center; background-size: contain; }
  .dialog_title { margin: 9px auto 26px auto; font-size: 12px; font-weight: 400; line-height: 12px; color: $color; text-align: center; }

  .qr_box { display: flex; flex-direction: column; align-items: center; }
  .qr_title { margin-bottom: 8px; font-size: 16px; font-weight: bold; line-height: 16px; color: #333; }
  .qr {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 148px;
    height: 148px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;

    .wechat_icon { position: absolute; top: 50%; left: 50%; width: 50px; height: 50px; background-image: url(~@/assets/images/icon_dialog_wechat.png); background-size: cover; transform: translate(-50%, -50%); }
  }
  .desc {
    margin: 13px auto 20px auto;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    line-height: 14px;
    color: #666;

    strong { font-weight: bold; }
  }

  .user_agreement_box {
    margin-bottom: 20px;
    text-align: center;

   .font { display: inline-block; font-size: 12px; font-weight: 400; line-height: 12px; color: #666; }
   .agreement { color: $color; text-decoration: none; cursor: pointer; }
  }

  .login_box { display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 0; }
  .login_item {
    display: inline-block;
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-image: url(~@/assets/images/icon_dialog_qq.png);
    background-size: cover;

    &:hover { background-image: url(~@/assets/images/icon_dialog_qq_hover.png); }
  }
  .login_item_desc { margin-top: 7px; font-size: 12px; line-height: 12px; color: #666; }
}
</style>
